import { useMutation, useQueryClient } from '@tanstack/react-query';
import { message } from 'antd';

import { useTranslation } from 'react-i18next';

import { NSKeys } from '@app/i18n';
import { CreateProductSchema } from '@app/models/products';
import Api from '@app/services/api';

interface IProps {
  catalog_uid: string;
  data: CreateProductSchema;
}

export const useCreateProductFromCatalogQuery = () => {
  const client = useQueryClient();
  const commonT = useTranslation(NSKeys.common);

  return useMutation({
    mutationFn: async ({ data, catalog_uid }: IProps) => {
      await Api.products.createProductFromCatalog(catalog_uid, data);
    },
    onError: () => {
      message.open({
        type: 'error',
        content: commonT.t('error400'),
      });
    },
    onSuccess: async () => {
      await client.invalidateQueries(['getCatalogProducts']);
      await client.invalidateQueries(['getCatalogProductsTable']);
      message.open({
        type: 'success',
        content: commonT.t('dataAddSuccess'),
      });
    },
  });
};
